import { render, staticRenderFns } from "./BowContentListMediaSx.vue?vue&type=template&id=73e48aec&"
import script from "./BowContentListMediaSx.vue?vue&type=script&lang=js&"
export * from "./BowContentListMediaSx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BowContentListMedia: require('/workspace/components/organisms/BowContentListMedia/BowContentListMedia.vue').default})
